export type SharedLineupSummaryRow = {
  playerName: string;
  battingSlot: number | null;
  inningsPlayed: number;
  inningsSat: number;
  pitchingInnings: number;
  catchingInnings: number;
};

export type SharedLineupPayload = {
  version: 1;
  teamName: string;
  title: string;
  gameDate: string;
  opponentName: string;
  inningsPlanned: number;
  outfieldMode: "THREE" | "FOUR";
  notes: string;
  battingOrder: string[];
  positions: string[];
  defensiveAssignments: Record<string, Record<string, string>>;
  summaryRows: SharedLineupSummaryRow[];
};

const toUrlSafeBase64 = (value: string) => value.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");

const fromUrlSafeBase64 = (value: string) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padLength = normalized.length % 4;
  if (padLength === 0) {
    return normalized;
  }
  return `${normalized}${"=".repeat(4 - padLength)}`;
};

export const encodeSharedLineupPayload = (payload: SharedLineupPayload): string => {
  const json = JSON.stringify(payload);
  const bytes = new TextEncoder().encode(json);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return toUrlSafeBase64(btoa(binary));
};

export const decodeSharedLineupPayload = (token: string): SharedLineupPayload | null => {
  try {
    const binary = atob(fromUrlSafeBase64(token));
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    const json = new TextDecoder().decode(bytes);
    const parsed = JSON.parse(json) as SharedLineupPayload;
    if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.battingOrder) || !parsed.defensiveAssignments) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};
